import { Injectable, OnDestroy } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Subscription } from 'rxjs';
import { TokenJWT } from 'src/app/core/models/token/token-jwt';
import { TokenService } from 'src/app/core/services/token/token.service';
import { environment } from 'src/environments/environment';

export type StripeSector = 'pet_diet' | 'sos';

@Injectable({
  providedIn: 'root',
})
export class StripeService implements OnDestroy{
  private token: TokenJWT | undefined; // informazioni dell'account
  private tokenSubscription$: Subscription = new Subscription();
  private stripeInstances: Partial<Record<StripeSector, Stripe | null>> = {};

  constructor(
    private tokenService: TokenService
  ) {
    this.getToken();
  }

  ngOnDestroy(): void {
    if (this.tokenSubscription$) this.tokenSubscription$.unsubscribe();
  }

  private getToken(): void {
    this.tokenSubscription$ = this.tokenService
      .getToken()
      .subscribe((token) => {
        this.token = token;
      });
  }

  async initialize(sector: StripeSector = 'pet_diet'): Promise<Stripe | null> {
    const key = environment.stripe[sector].publicKey;
    this.stripeInstances[sector] = await loadStripe(key, { locale: 'it' });
    return this.stripeInstances[sector] ?? null;
  }

  getStripe(sector: StripeSector = 'pet_diet'): Stripe | null {
    return this.stripeInstances[sector] ?? null;
  }

  /**
   * Crea un account stripe
   * @param token string
   */
  public async createStripeAccount(sector: StripeSector = 'pet_diet'){
    try {
      const response = await fetch(
        environment.apiUrl +
        environment.apiVersion +
        '/accounts/payment-system/account/create',
        {
          headers: {
            Authorization: this.token!.toString(),
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({ sector }),
        }
      );

      let data = await response.json();

      if (!response.ok) {
        throw new Error(`${data.description}`);
      }

    } catch (error) {
      console.error(error);
      Promise.resolve(false);
    }
  }
}
